import secureLocalStorage from 'react-secure-storage';

export const getPokemonFromStorage = () => {
  const pokemonFromStorage = secureLocalStorage.getItem('pokemonInfoRandom');
  return pokemonFromStorage ? JSON.parse(pokemonFromStorage) : null;
};

export const getPokemonFromStorageCries = () => {
  const pokemonFromStorage = secureLocalStorage.getItem('pokemonInfoRandomCries');
  return pokemonFromStorage ? JSON.parse(pokemonFromStorage) : null;
};

export const getPokemonFromStorageEmoji = () => {
  const pokemonFromStorage = secureLocalStorage.getItem('pokemonInfoRandomEmoji');
  return pokemonFromStorage ? JSON.parse(pokemonFromStorage) : null;
};
